export const preferencesActionTypes = {
    // FETCH (GET /v1/co/users/me/preferences)
    PREFERENCES_FETCH_REQUEST: 'PR1',
    PREFERENCES_FETCH_SUCCESS: 'PR2',
    PREFERENCES_FETCH_FAILURE: 'PR3',

    // PATCH (PATCH /v1/co/users/me/preferences)
    PREFERENCES_PATCH_REQUEST: 'PR4',
    PREFERENCES_PATCH_SUCCESS: 'PR5',
    PREFERENCES_PATCH_FAILURE: 'PR6',
    PREFERENCES_PATCH_REVERT: 'PR7',

    // OS-level system theme change (matchMedia listener)
    SYSTEM_THEME_CHANGED: 'PR8',

    // RESET (sign out)
    PREFERENCES_RESET: 'PR9',
    // 'PR10' retired (was INPUT_MODE_DETECTED — wheel-heuristic device
    // detection for input_mode 'auto'; removed for now, may return)
};
